import * as React from "react";
import {
  Layout,
  MenuProps,
  LayoutProps,
  MenuItemLink,
  useResourceDefinitions,
} from "react-admin";
import { Divider, Box } from "@mui/material";

const hiddenRessources = [
  "clientInventory",
  "providerInventory",
  "outletInventory",
];

const MyMenu: React.FC<MenuProps> = ({ onMenuClick, logout }) => {
  const resources = useResourceDefinitions();

  return (
    <Box sx={{ mt: 1 }}>
      {Object.values(resources)
        .filter((r) => !hiddenRessources.includes(r.name))
        .map((r) => (
          <React.Fragment key={r.name}>
            <MenuItemLink
              to={`/${r.name}`}
              primaryText={r.options?.label || r.name}
              leftIcon={React.createElement(r.icon!)}
              onClick={onMenuClick}
            />
            <Divider />
          </React.Fragment>
        ))}
      {logout}
    </Box>
  );
};

export const MainLayout: React.FC<LayoutProps> = (props) => {
  return <Layout {...props} menu={MyMenu} />;
};
